import { type FC, useState } from 'react';
import 'grommet';
import { Button } from 'grommet';
import { Box, BoxProps, Text } from '/src/components';

export const DropMenuButton: FC<DropMenuButtonProps> = (props) => {
  const { label, onClick, ...boxProps } = props;

  const [isHover, setIsHover] = useState(false);

  return (
    <Box
      justify="center"
      pad="xsmall"
      background={isHover ? 'light-5' : 'light-4'}
      elevation={isHover ? 'small' : undefined}
      border={{ color: 'light-2', size: '0.05rem' }}
      borderRadius="6px"
      onMouseOver={() => setIsHover(true)}
      onMouseOut={() => setIsHover(false)}
      {...boxProps}
    >
      <Button onClick={() => onClick?.()}>
        <Text alignSelf="center" size="1rem" weight={500}>
          {label}
        </Text>
      </Button>
    </Box>
  );
};

export type DropMenuButtonProps = BoxProps & {
  label?: string;
  onClick?: () => void;
};
